import type { PortalProps } from '@common/components';
import { Portal, Slot } from '@common/components';
import { cn } from '@core/utils';

import { SELECTOR } from '@/constants';

interface BottomNavPortalProps
  extends Pick<PortalProps, 'onLoaded' | 'children'> {
  hasShadow?: boolean;
  wrapperClassName?: string;
}

export const BottomNavPortal = ({
  children,
  onLoaded,
  hasShadow = true,
  wrapperClassName,
}: BottomNavPortalProps) => {
  return (
    <Portal
      renderTo={() => document.getElementById(SELECTOR.MAIN_WRAPPER)}
      onLoaded={onLoaded}
    >
      <div
        className={cn(
          'fixed inset-x-0 bottom-0 z-20 flex justify-center bg-Gray-white pb-[var(--safe-area-bottom,0px)]',
          wrapperClassName,
        )}
      >
        <div className="relative w-full max-w-screen-xl xl:max-w-[600px]">
          <Slot
            className={cn({
              'shadow-large': hasShadow,
            })}
          >
            {children}
          </Slot>
        </div>
      </div>
    </Portal>
  );
};
